import { createBrowserRouter } from "react-router-dom";
import { PrivateRoute, AdminRoute } from "./components/PrivateRoute";
import { InfositeLayout } from "./layouts/InfositeLayout";

// Infosite pages
import { HomePage } from "./pages/infosite/HomePage";
import { FeaturesPage } from "./pages/infosite/FeaturesPage";
import { PricingPage } from "./pages/infosite/PricingPage";
import { RequestAccessPage } from "./pages/infosite/RequestAccessPage";
import { PrivacyPage } from "./pages/infosite/PrivacyPage";
import { TermsPage } from "./pages/infosite/TermsPage";
import { StrategyPage } from "./pages/infosite/StrategyPage";

// Auth pages
import { LoginPage } from "./pages/auth/LoginPage";
import { ForgotPasswordPage } from "./pages/auth/ForgotPasswordPage";
import { AcceptInvitePage } from "./pages/auth/AcceptInvitePage";

// Dashboard
import { DashboardLayout } from "./layouts/DashboardLayout";
import { DashboardPage } from "./pages/dashboard/DashboardPage";
import { UsersPage } from "./pages/dashboard/UsersPage";
import { VotersPage } from "./pages/dashboard/VotersPage";
import { VoterImportPage } from "./pages/dashboard/VoterImportPage";
import { SurveysPage } from "./pages/dashboard/SurveysPage";
import { SurveyBuilderPage } from "./pages/dashboard/SurveyBuilderPage";
import { TagsPage } from "./pages/dashboard/TagsPage";

export const router = createBrowserRouter([
  // Infosite (public, with nav/footer)
  {
    element: <InfositeLayout />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/features", element: <FeaturesPage /> },
      { path: "/pricing", element: <PricingPage /> },
      { path: "/request-access", element: <RequestAccessPage /> },
      { path: "/privacy", element: <PrivacyPage /> },
      { path: "/terms", element: <TermsPage /> },
      { path: "/strategy", element: <StrategyPage /> },
    ],
  },

  // Auth (public, standalone — no nav/footer)
  { path: "/login", element: <LoginPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/accept-invite", element: <AcceptInvitePage /> },

  // Dashboard (protected)
  {
    element: <PrivateRoute />,
    children: [
      {
        element: <DashboardLayout />,
        children: [
          { path: "/dashboard", element: <DashboardPage /> },
          { path: "/dashboard/voters", element: <VotersPage /> },
          { path: "/dashboard/surveys", element: <SurveysPage /> },
          {
            element: <AdminRoute />,
            children: [
              { path: "/dashboard/users", element: <UsersPage /> },
              { path: "/dashboard/voters/import", element: <VoterImportPage /> },
              { path: "/dashboard/surveys/new", element: <SurveyBuilderPage /> },
              { path: "/dashboard/surveys/:id/edit", element: <SurveyBuilderPage /> },
              { path: "/dashboard/tags", element: <TagsPage /> },
            ],
          },
        ],
      },
    ],
  },
]);
